import axios from 'axios';
import qs from 'qs';
import cookie from '../cookieHelper/cookie'; // Assuming you have a cookie helper

export default function addCompany(data) {
    const API_URL = process.env.REACT_APP_BASE_URL + '/api/v1/company';

    // Retrieve the authentication token from cookies
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);


    return (
        axios.post(API_URL, qs.stringify(data), {
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        })
        .then(res => {
            // console.log("res: ", res);
            return res.data;
        })
        .catch(err => {
            // console.log("err: ", err);
            return err;
        })
    );
}
